// TODO: affiliate task
// const Cookies = require('js-cookie')
// const { BUCKET_COOKIE, lookupAffiliateRedirect } = require('./src/utils/affiliateRedirects')
const { capiTrackSourceMiddleware } = require('./src/utils/capiMatchParameters')
const { initWebVitalsTracking } = require('./src/utils/webVitals')
const { captureAttributionCookies } = require('./src/utils/attributionCookies')

// Registered at client entry so it lands in the Segment snippet queue before
// any event fires.
exports.onClientEntry = () => {
  // Register web-vitals early: the library defers all measurement work, but
  // registering late loses metrics.
  initWebVitalsTracking()

  captureAttributionCookies()

  if (typeof window !== 'undefined' && window.analytics && window.analytics.addSourceMiddleware) {
    window.analytics.addSourceMiddleware(capiTrackSourceMiddleware)
  }
}

// Redirect bucketed users away from canonical Magician URLs to their -aff
// variants before the new page component mounts. Eliminates the flash of
// Eden pricing that ExperimentContext's effect-based redirect produced on
// SPA navigation.
// TODO: affiliate task
// exports.onPreRouteUpdate = ({ location }) => {
//   if (typeof window === 'undefined') return
//   if (Cookies.get(BUCKET_COOKIE) !== '1') return
//   const target = lookupAffiliateRedirect(location.pathname)
//   if (target) {
//     window.location.replace(target + location.search + location.hash)
//   }
// }
